import { $themeConfig } from '@themeConfig'
import { defineStore } from 'pinia'

export const useVerticalMenuStore = defineStore('VerticalMenuStore', {
  state: () => {
    return {
      isVerticalMenuCollapsed: $themeConfig.layout.menu.isCollapsed,
    }
  },
  getters: {},
  actions: {
    updateVerticalMenuCollapsed(val) {
      this.isVerticalMenuCollapsed = val
    },
  },
})
